import {useEffect, useState} from "react";
import {HexColorPicker} from "react-colorful";
import {Button, Col, FormControl, FormLabel, InputGroup, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {t} from "i18next";
import {faEyeDropper} from "@fortawesome/free-solid-svg-icons";

const CustomColorPicker = ({value, onChange, defaultColors, mandatory = false}) => {
    const color = value;
    const setColor = onChange;
    const [showColorPicker, setShowColorPicker] = useState(false);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest(".custom-color-picker")) {
                setShowColorPicker(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, [])

    return (
        <div className="position-relative">
            <Row>
                <Col xl={3} className="custom-color-picker">
                    <InputGroup style={{cursor: "pointer"}}>
                        <InputGroup.Text onClick={() => setShowColorPicker(!showColorPicker)}
                                         style={{backgroundColor: color, width: "46px"}}>
                            {
                                !color &&
                                <FontAwesomeIcon icon={faEyeDropper}/>
                            }
                        </InputGroup.Text>
                        <FormControl
                            placeholder={t('categories.creation.fields.colorPlaceholder')}
                            value={color}
                            onChange={(e) => setColor(e.target.value)}
                        ></FormControl>
                    </InputGroup>
                </Col>
            </Row>
            {
                showColorPicker &&
                <div className="position-absolute p-4 bg-gray-700 rounded-3 custom-color-picker"
                     style={{top: "90px", width: "330px"}}>
                    <span className="text-gray-200">Selecciona color</span>
                    <HexColorPicker color={color || ""} onChange={setColor}/>
                    <div className="d-flex justify-content-center">
                        <FormControl
                            className="mt-4 bg-transparent text-center w-50"
                            value={color}
                            onChange={(e) => setColor(e.target.value)}
                        >
                        </FormControl>
                    </div>
                </div>
            }
        </div>
    );
};

export default CustomColorPicker;